import { Heading, HeadingProps } from "@chakra-ui/react";

export {
  Heading12, Heading14, Heading16, Heading18, Heading20, Heading22,
} from "design-system/primitives/HeadingSizes";

export function DashboardHeading({ children, ...rest }: HeadingProps) {
  return (
    <Heading size="2xs" fontSize="lg" fontWeight="semibold" {...rest}>
      {children}
    </Heading>
  );
}

export function BlueHeading({ children, ...rest }: HeadingProps) {
  return (
    <Heading color="linkBlue.500" size="2xs" fontSize="lg" fontWeight="semibold" {...rest}>
      {children}
    </Heading>
  );
}
